import { search, selling } from './routes';

export interface NavigationLink {
  id: string;
  shortId: string;
  name: string;
  pathRef: string;
  navUrl: string;
  routes: any[]; // Adjust the type of routes if you have a more specific type
  ariaLabel: string;
}

export const getRouteSegment = (link: NavigationLink) => link.pathRef.split('/').at(-1) || '';

export default [
  {
    id: selling.meta.id,
    shortId: 'selling',
    name: selling.meta.name,
    pathRef: selling.meta.path,
    navUrl: '/',
    routes: selling.routes,
    ariaLabel: 'Myymässä, alavalikko',
  },
  {
    id: search.sale.meta.id,
    shortId: 'buying',
    name: search.sale.meta.name,
    pathRef: search.sale.meta.path,
    navUrl: search.sale.meta.path,
    routes: search.sale.routes,
    ariaLabel: 'Ostamassa, alavalikko',
  },
  {
    id: search.rental.meta.id,
    shortId: 'renting',
    name: search.rental.meta.name,
    pathRef: search.rental.meta.path,
    navUrl: search.rental.meta.path,
    routes: search.rental.routes,
    ariaLabel: 'Vuokraamassa, alavalikko',
  },
] as NavigationLink[];
